import { render } from "./GamefamGameStats.vue?vue&type=template&id=124af55b&scoped=true"
import script from "./GamefamGameStats.vue?vue&type=script&lang=js"
export * from "./GamefamGameStats.vue?vue&type=script&lang=js"

import "./GamefamGameStats.vue?vue&type=style&index=0&id=124af55b&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124af55b"]])

export default __exports__